import React, {
  Fragment,
  useContext,
  useEffect,
  useCallback,
  useState,
} from "react";
import {
  Typography,
  Divider,
  Card,
  CardContent,
  InputBase,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SwaggerUI from "swagger-ui-react";
import "../../Component/Paragraph/mea-ui.css";

import { LangContext } from "../../Context/Langcontext";

import MEA_DataService from "./data/TH/mea_data_service";
import MEA_DataService_en from "./data/EN/mea_data_service";
import MEA_MapService from "./data/TH/mea_map_service";
import MEA_MapService_en from "./data/EN/mea_map_service";
import ScsTH from "./scs/scs_TH";
import ScsEN from "./scs/scs_EN";
import AddressEN from "./amn/awn_EN";
import AddressTH from "./amn/awn_TH";
import Description from "./description";
import { getoneAPIkey } from "../../API/apikey";
// import { UserContext } from "../../Context/UserContext";

const useStyles = makeStyles((theme) => ({
  mainText: {
    color: "#E16733",
    fontSize: "1.2rem",
    fontWeight: 700,
  },
  secondText: {
    color: "#595A5A",
    fontSize: "1rem",
    fontWeight: 200,
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  detailTexT: {
    color: "#E16733",
    fontSize: "1.2rem",
    fontWeight: 400,
    marginTop: "1rem",
  },
  parameterText: {
    color: "#595A5A",
    fontSize: "1.2rem",
    fontWeight: 200,
    marginTop: "1rem",
  },
  cardstyle: {
    maxWidth: "100%",
    boxShadow: "unset",
    backgroundColor: "#f1f1f1",
    marginTop: "1rem",
  },
  title: {
    fontWeight: 700,
    padding: "0.15rem",
    backgroundColor: "#f5f5f5",
    marginRight: "0.5rem",
  },
  copy: {
    width: "100%",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    position: "absolute",
    top: "0.5rem",
    right: "0.5rem",
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  cardapi: {
    width: "100%",
    borderRadius: 8,
    backgroundColor: "#f1f1f1",
    boxShadow: "unset",
    marginTop: "1rem",
    "& .MuiCardContent-root:last-child": {
      padding: "10px 20px 10px 10px",
    },
    "& .MuiCardContent-root": {
      padding: "12px",
    },
  },
  inputStyle: {
    fontWeight: 200,
    fontSize: "1rem",
    color: "#595A5A",
  },
  gridunderline: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
  gridunder: {},
  codeText: {
    color: "#595A5A",
    fontSize: "1rem",
    fontWeight: 700,
    marginBottom: "0.5rem",
  },
}));

const Dataservice = () => {
  const classes = useStyles();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  // const userContext = useContext(UserContext);
  const [apikey, setapikey] = useState(undefined);

  const code = [
    { title: "apikey", detail: lang.YourAPI },
    {
      title: "q",
      detail: lang.Qparam,
    },
    {
      title: "z",
      detail: lang.Zparam,
    },
    {
      title: "type",
      detail: lang.Typeparam,
    },
    {
      title: "mt",
      detail: lang.Mtparam,
    },
    {
      title: "init_data",
      detail: lang.InitDataParam,
    }
  ];

  const initApikey = useCallback(async () => {
    const data = await getoneAPIkey();
    if (data.data.length) {
      setapikey(data.data[0].api_key);
    }
  }, []);

  useEffect(() => {
    if (
      !localStorage.getItem("mea") &&
      localStorage.getItem("role") !== "admin" &&
      localStorage.getItem("role") !== "root"
    ) {
    } else {
      if (!apikey) {
        initApikey();
      }
    }

    return () => {};
  }, [apikey, initApikey]);

  return (
    <div style={{ margin: "1rem 2rem" }}>
      <Typography className={classes.mainText}>{lang.DataService}</Typography>

      <div id="mea_data_service">
        {langContext.lang.locale === "th" ? (
          <SwaggerUI
            docExpansion="list"
            displayRequestDuration="true"
            spec={MEA_DataService}
            style={{ fontWeight: "400", fontFamily: "Prompt" }}
          />
        ) : (
          <SwaggerUI
            docExpansion="list"
            displayRequestDuration="true"
            spec={MEA_DataService_en}
            style={{ fontWeight: "400", fontFamily: "Prompt" }}
          />
        )}
      </div>
      <Divider className={classes.divider} />
      <Typography className={classes.mainText}>{lang.MapService}</Typography>

      <div id="mea_map_service">
        {langContext.lang.locale === "th" ? (
          <SwaggerUI
            docExpansion="list"
            displayRequestDuration="true"
            spec={MEA_MapService}
            style={{ fontWeight: "400", fontFamily: "Prompt" }}
          />
        ) : (
          <SwaggerUI
            docExpansion="list"
            displayRequestDuration="true"
            spec={MEA_MapService_en}
            style={{ fontWeight: "400", fontFamily: "Prompt" }}
          />
        )}
      </div>
      <Divider className={classes.divider} />
      <div id="description">
        <Description />
      </div>
      {localStorage.getItem("token") ? (
        !localStorage.getItem("mea") &&
        localStorage.getItem("role") !== "admin" &&
        localStorage.getItem("role") !== "root" ? null : (
          <Fragment>
            <Divider className={classes.divider} />
            <Typography className={classes.mainText}>SCS</Typography>
          </Fragment>
        )
      ) : null}

      <div id="scs">
        {localStorage.getItem("token") ? (
          !localStorage.getItem("mea") &&
          localStorage.getItem("role") !== "admin" &&
          localStorage.getItem("role") !== "root" ? null : langContext.lang
              .locale === "th" ? (
            <SwaggerUI
              docExpansion="list"
              displayRequestDuration="true"
              spec={ScsTH}
              style={{ fontWeight: "400", fontFamily: "Prompt" }}
            />
          ) : (
            <SwaggerUI
              docExpansion="list"
              displayRequestDuration="true"
              spec={ScsEN}
              style={{ fontWeight: "400", fontFamily: "Prompt" }}
            />
          )
        ) : null}

        {localStorage.getItem("token") ? (
          !localStorage.getItem("mea") &&
          localStorage.getItem("role") !== "admin" &&
          localStorage.getItem("role") !== "root" ? null : (
            <Fragment>
              <Divider className={classes.divider} />
              <Typography className={classes.mainText}>
                {lang.UsingSCS}
              </Typography>
              <Card className={classes.cardapi}>
                <CardContent className={classes.cardcontent}>
                  <InputBase
                    type={"text"}
                    value={`${process.env.REACT_APP_WEB_URL}/embed/apikey={your API-Key}?q={center map}&z={zoom level}&type={ operate type }&mt={base map}&init_data=true`}
                    disabled
                    fullWidth
                    style={{ minWidth: 100 }}
                    inputProps={{
                      className: classes.inputStyle,
                    }}
                  />
                </CardContent>
              </Card>
              <Divider className={classes.divider} />

              <Typography className={classes.mainText}>
                {lang.UsageParameter}
              </Typography>
              <Grid container style={{ margin: "0.5rem 0rem" }}>
                <Grid
                  item
                  md={3}
                  sm={6}
                  xs={6}
                  className={classes.gridunderline}
                >
                  <Typography className={classes.codeText}>
                    {lang.Parameter}
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sm={6}
                  xs={6}
                  className={classes.gridunderline}
                >
                  <Typography className={classes.codeText}>
                    {lang.Description}
                  </Typography>
                </Grid>
                <Grid item md={3}></Grid>
                {code.map((rs, index) => {
                  return (
                    <Grid container key={`${index}_${rs.title}`}>
                      <Grid
                        item
                        md={3}
                        sm={6}
                        xs={6}
                        className={
                          index === code.length - 1
                            ? classes.gridunder
                            : classes.gridunderline
                        }
                      >
                        <Typography className={classes.secondText}>
                          {rs.title}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        md={6}
                        sm={6}
                        xs={6}
                        className={
                          index === code.length - 1
                            ? classes.gridunder
                            : classes.gridunderline
                        }
                      >
                        <Typography className={classes.secondText}>
                          {rs.detail}
                        </Typography>
                      </Grid>
                      <Grid item md={3}></Grid>
                    </Grid>
                  );
                })}
              </Grid>
              <Divider className={classes.divider} />

              <Typography className={classes.mainText}>
                {lang.SCSExample}
              </Typography>
              <Card className={classes.cardapi}>
                <CardContent className={classes.cardcontent}>
                  <InputBase
                    type={"text"}
                    value={`<iframe  width="50%" height="50%" frameborder="0" allow="geolocation" src=${
                      process.env.REACT_APP_WEB_URL
                    }/embed/apikey=${
                      apikey ? "{ Api Key }" : "กรุณาสร้าง API Key"
                    }?q=100.554894,13.721237&z=15&type=public&mt=vectortile></iframe>`}
                    disabled
                    fullWidth
                    style={{ minWidth: 100 }}
                    inputProps={{
                      className: classes.inputStyle,
                    }}
                  />
                </CardContent>
              </Card>
              <Grid container>
                <Grid item md={12} sm={12} xs={12}>
                  <div style={{ margin: "2rem 0rem" }}>
                    <div style={{ width: "100%", height: "45vh" }}>
                      <iframe
                        title="MEA"
                        width="100%"
                        height="100%"
                        frameborder="0"
                        allow="geolocation"
                        src={`${
                          document.location.hostname === "localhost"
                            ? "http://localhost:3000"
                            : process.env.REACT_APP_WEB_URL
                        }/embed/apikey=${
                          document.location.hostname === "localhost"
                            ? "http://localhost:3000"
                            : apikey
                        }?q=100.554894,13.721237&z=15`}
                      ></iframe>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Fragment>
          )
        ) : null}
      </div>

      <div id="address">
        {langContext.lang.locale === "th" ? (
          <SwaggerUI
            docExpansion="list"
            displayRequestDuration="true"
            spec={AddressTH}
            style={{ fontWeight: "400", fontFamily: "Prompt" }}
          />
        ) : (
          <SwaggerUI
            docExpansion="list"
            displayRequestDuration="true"
            spec={AddressEN}
            style={{ fontWeight: "400", fontFamily: "Prompt" }}
          />
        )}
      </div>
      {/* <div id="premium">

      </div> */}
    </div>
  );
};

export default Dataservice;
